export const SESSION_USAGE_ENTITIES = { FLOW: 'Flow', EVENT: 'Event' } as const;
export type SessionUsageEntity = (typeof SESSION_USAGE_ENTITIES)[keyof typeof SESSION_USAGE_ENTITIES];
